const trimData = (data) => {
  return Object.keys(data).reduce((acc, key) => {
     acc[key] = typeof data[key] === 'string' ? data[key].trim() : data[key];
     return acc;
   }, {});
 }

 export default trimData;